/** Labels of the "Available Stock" table (`./AvailableStock.tsx`) in en / fr / es. */
import { LanguageContent } from "@ryerson/frontend.common";

/** Label keys of the table. `tbd` replaces the quantity when availability is not known. */
export interface AvailableStockText {
	availableStock: string;
	quantity: string;
	dateAvailable: string;
	tbd: string;
}

/** Table labels by language. */
export const AvailableStockContent: LanguageContent<AvailableStockText> = {
	en: {
		availableStock: "Available Stock",
		quantity: "Quantity",
		dateAvailable: "Date Available",
		tbd: "TBD",
	},
	fr: {
		availableStock: "Stock Disponible",
		quantity: "Quantité",
		dateAvailable: "Date De Disponibilité",
		tbd: "À DÉT",
	},
	es: {
		availableStock: "Inventario Disponible",
		quantity: "Cantidad",
		dateAvailable: "Fecha Disponible",
		tbd: "POR DEFINIRSE",
	},
};
